export default "__VITE_ASSET__IizVgK9$__"